<template>
  <v-container fluid>
    <div class="row row--dense">
      <v-col cols="12" xl="12" lg="12">
        <div class="d-flex justify-space-between flex-wrap" >
          <div class="d-flex bordered qp-tab-nav ">
            <div class="d-flex p-2">
              <template >
                <div class="nv_item d-flex p-4 pointer" @click="gotoPage('/sales-team')">
                  <SvgIcon class="text-xl qp-tab-nav-is-active" text="Sales Teams" >
                    <template v-slot:icon>
                      <DashboardIcon />
                    </template>
                  </SvgIcon>
                </div>
                <v-divider
                    vertical style="background-color: rgba(220, 220, 220, 1)"
                ></v-divider>
              </template>



              <template >
                <div class="nv_item d-flex p-4 pointer"   @click="gotoPage('/sales-team/deals')">
                  <SvgIcon class="text-xl  text-thin-black " text="Sales Deals" >
                    <template v-slot:icon>
                      <AnalyticsIcon />
                    </template>
                  </SvgIcon>
                </div>
              </template>
            </div>
          </div>

          <div class="d-flex gap-x-2">
            <v-text-field
                v-model="search"
                class="q-text-field shadow-0 bg-white"
                dense
                height="48"
                hide-details
                outlined
                placeholder="Search Sales Team"
                @keyup="searchFilter"
            >
              <template #prepend-inner>
                <SearchIcon/>
              </template>
            </v-text-field>
            <v-select
                class="q-text-field shadow-0"
                v-model="statusId"
                outlined
                dense
                :height="48"
                hide-details="auto"
                :menu-props="{ bottom: true, offsetY: true }"
                item-value="value"
                item-text="label"
                :items="[ {label:'All', value:'all' }, {label:'Active', value:'1' }, {label:'Inactive', value:'2' } ]"
                validate-on-blur
                @change="getSalesTeam"
            ></v-select>

            <v-btn
                color=" darken-1"
                class="white--text blue-color ml-1"
                text
                height="48"
                @click="addSalesPerson"
            >
              <AddIcon/>
              <span class="ml-1">Add Person</span>
            </v-btn>
          </div>
        </div>
      </v-col>
    </div>
    <v-row>
      <v-col
          v-for="(data,index) in salesTeam"
          :key="index"
          lg="4"
          md="6"
          xl="3"
      >
        <SalesTeamCard :user="data" :refreshData="refreshData"/>
      </v-col>
    </v-row>
    <SalesTeamPopup :editDialog="editDialog" @close="close" />
  </v-container>
</template>
<script>
import SearchIcon from "@/assets/images/misc/search.svg";
import AddIcon from "@/assets/images/misc/plus-icon.svg";
import DashboardIcon from "@/assets/images/misc/dashboard-icon.svg";
import AnalyticsIcon from "@/assets/images/misc/dashboard-icon.svg";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import SalesTeamCard from "@/components/SalesTeam/SalesTeamCard.vue";
import SalesTeamPopup from "@/components/SalesTeam/SalesTeamPopup.vue";

export default {
  components: {SalesTeamCard, SalesTeamPopup, SvgIcon, SearchIcon, AddIcon, DashboardIcon,AnalyticsIcon},
  data() {
    return {
      refreshData:false,
      userID: null,
      salesTeam: [],
      search: "",
      statusId: "all",
      editDialog: false,
    };
  },
  mounted() {
    this.getSalesTeam();

  },
  watch: {
    page() {
      this.getSalesTeam();
    },
  },
  methods: {
    searchFilter(){
      setTimeout(()=> {
        this.showLoader('Searching..');
        this.getSalesTeam()
        this.hideLoader();
      },300)
    },
    gotoPage(route){
      this.$router.push(route);
    },
    getSalesTeam() {
      this.showLoader("Loading")
      let filter = '';

      if(this.statusId){
        filter +='status_id='+this.statusId;
      }
      if(this.search){
        filter +='&search='+this.search;
      }

      if(filter !== ''){
        filter = '?'+filter;
      }

      let url = "sales-team"+filter;
      this.$http
          .get(url)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.salesTeam = response.data.data.data;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.hideLoader()
          });
    },
    addSalesPerson() {
      this.editDialog = true;
    },
    close(){
      this.editDialog = false;
      this.getSalesTeam();
    }
  },
};
</script>
<style lang="scss" scoped>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  //.v-btn.v-btn {
  //  border-color: unset !important;
  //  padding-left: 0 !important;
  //  padding-right: 0 !important;
  //  &:not(:first-child)::before {
  //    content: " ";
  //    background: #a81b1b;
  //    height: 20px;
  //    width: 1px;
  //    position: unset !important;
  //    opacity: 1 !important;
  //    margin-left: 8px;
  //    margin-right: 8px ;
  //  }
  //}

}

</style>
